import React from 'react';
import PropTypes from 'prop-types';
import { Card, Input, FloatGroup, Select } from 'modules/common';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

export const VOTEPRO_METHOD_OPTIONS = [
  { value: '', label: 'All methods' },
  { value: 'registration_lookup', label: 'Check Your Registration' },
  { value: 'voter_registration', label: 'Register to Vote' },
  { value: 'absentee_ballot', label: 'Request an Absentee Ballot' },
  { value: 'early_vote', label: 'Find Early Vote' },
  { value: 'elections_day', label: 'Find Your Polling Place' },
  { value: 'return_ballot', label: 'Return Your Ballot' },
  { value: 'commit_to_vote', label: 'Commit to Vote' },
];

export function easternToday(now = new Date()) {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/New_York' }).format(now);
}

function VoteProSettings({ editedUpsell, onUpdateEditedUpsell }) {
  const today = easternToday();
  const endOn = editedUpsell.votepro_end_on || '';
  const savedPast = endOn !== '' && endOn < today;
  const selectedMethod =
    VOTEPRO_METHOD_OPTIONS.find(option => option.value === (editedUpsell.votepro_method || '')) ||
    VOTEPRO_METHOD_OPTIONS[0];
  const endDateSubtitle = savedPast
    ? 'This date is in the past. Donors will skip this step.'
    : 'Optional. Donors skip this step after the end of this day, US Eastern.';

  return (
    <>
      <Row className="mt-4">
        <Col sm={12} md={12}>
          <Card.Title subtitle="Limit the widget to one action, or leave all methods available.">Open to</Card.Title>
          <Select
            name="votepro_method"
            label="Open to"
            isSearchable={false}
            numberOfDropdownItems={VOTEPRO_METHOD_OPTIONS.length}
            disabled={editedUpsell._isDisabled}
            value={selectedMethod}
            options={VOTEPRO_METHOD_OPTIONS}
            onChange={onUpdateEditedUpsell}
            placeholder="Open to"
          />
        </Col>
      </Row>

      <Row className="mt-4">
        <Col sm={12} md={12}>
          <Card.Title subtitle={endDateSubtitle}>End date</Card.Title>
          <FloatGroup noLabel>
            <Input
              type="date"
              name="votepro_end_on"
              ariaLabel="End date"
              min={today}
              value={endOn}
              disabled={editedUpsell._isDisabled}
              onChange={onUpdateEditedUpsell}
            />
          </FloatGroup>
        </Col>
      </Row>
    </>
  );
}

VoteProSettings.propTypes = {
  editedUpsell: PropTypes.object.isRequired,
  onUpdateEditedUpsell: PropTypes.func.isRequired,
};

export default VoteProSettings;
